import { Grid } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import DashboardReceivingDeliveryForm from '../SubForms/DashboardReceivingDeliveryForm';
import CreateOrderContainer from '../Receiving/CreateOrder/CreateOrderContainer';
import DashboardTagContainer from '../Receiving/DashboardTagContainer';
import DashboardTabVerify from '../Receiving/DashboardTabVerify';
import ChartData from '../Charts/ChartData';
import DashboardAssetTable from './DashboardAssetTable';
import DashboardReceivingTableData from './DashboardReceivingTableData';

import { observer } from 'mobx-react-lite';
import DashboardTagTable from './DashboardTagTable';
import DashboardCreateOrderTable from './DashboardCreateOrderTable';
import CRMRegister from '../SubForms/CRMRegister';

function DashboardGridReceiving() {
  const {
    dashboardStore: {
      dashboard: { L2CardValueInventory, valueForL3Inventory },
    },
    userStore:{user}
  } = useStore();

  return (
    <div id="parent-grid-receiving">
      {L2CardValueInventory === 'Receiving' &&
        valueForL3Inventory === 'Register' && (
          <>
            {(user?.customerName === 'PCPLCRM' && user?.roleName.trim() === 'CRM') ? (
              <CRMRegister />
            ) : (
              <DashboardReceivingDeliveryForm />
            )}
          </>
        )}
      {/* verify */}
      {L2CardValueInventory === 'Receiving' &&
        valueForL3Inventory === 'Verify' && (
          <Grid stackable columns={2}>
            <Grid.Column>
              <DashboardReceivingTableData />
            </Grid.Column>
            <Grid.Column>
              <DashboardTabVerify />
            </Grid.Column>
          </Grid>
        )}
      {/* tag */}

      {L2CardValueInventory === 'Receiving' &&
        valueForL3Inventory === 'Tag' && (
          <Grid stackable columns={2}>
            <Grid.Column>
              <DashboardTagTable />
            </Grid.Column>
            <Grid.Column>
              <DashboardTagContainer />
            </Grid.Column>
          </Grid>
        )}
      {/* for create Order */}
      {L2CardValueInventory === 'Receiving' &&
        valueForL3Inventory === 'Create Order Receiving' && (
          <Grid stackable columns={2}>
            <Grid.Column>
              <DashboardCreateOrderTable />
            </Grid.Column>
            <Grid.Column>
              <CreateOrderContainer name={'Assign Activities'} />
            </Grid.Column>
          </Grid>
        )}

      {L2CardValueInventory === 'Receiving' &&
        valueForL3Inventory === 'Reports' && (
          <Grid stackable>
            <Grid.Row>
              <ChartData />
            </Grid.Row>
            <Grid.Row>
              <DashboardAssetTable />
            </Grid.Row>
          </Grid>
        )}
    </div>
  );
}

export default observer(DashboardGridReceiving);
